/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */
'use strict';

var keyOf = require('fbjs/lib/keyOf');
/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */


var DefaultEventPluginOrder = [keyOf({
  ResponderEventPlugin: null
}), keyOf({
  SimpleEventPlugin: null
}), keyOf({
  TapEventPlugin: null
}), keyOf({
  EnterLeaveEventPlugin: null
}), keyOf({
  ChangeEventPlugin: null
}), keyOf({
  SelectEventPlugin: null
}), keyOf({
  BeforeInputEventPlugin: null
})];
module.exports = DefaultEventPluginOrder;